<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="4">
                <ListGroupCard
                    :title="'Services'"
                    :model="entityEventListeners"
                    :fetchOnInit="false"
                    filterKey="group.item.name"
                >
                    <div slot="cardHeader">
                        <b-button
                            variant="success"
                            class="float-right"
                            size="sm"
                            @click="addEventListener"
                        >
                            <i class="fa fa-users" /> Add listener
                        </b-button>
                    </div>
                    <b-list-group-item
                        slot="modelContainer"
                        slot-scope="listener"
                        action
                        @click="setListener(listener)"
                    >
                        <small
                            >{{ listener.item.entity }}@{{
                                listener.item.event
                            }}</small
                        >
                        <h5 class="mb-1">{{ listener.item.name }}</h5>
                        <div class="mb-1">
                            <b-badge
                                class="float-sm-right"
                                variant="success"
                                pill
                                v-if="listener.item.enabled"
                                >Enabled</b-badge
                            >
                            <b-badge
                                class="float-sm-right"
                                variant="danger"
                                pill
                                v-if="!listener.item.enabled"
                                >Disabled</b-badge
                            >
                            <div class="float-sm-left">
                                {{ listener.item.description }}
                            </div>
                        </div>
                    </b-list-group-item>
                </ListGroupCard>
            </b-col>
            <b-col md="8">
                <EntityEventListener v-if="listener" :listener="listener" />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import GenericCollection from '@/models/GenericCollection'
import ListGroupCard from '@/components/ListGroupCard'
import EntityEventListener from './EntityEventListener'

export default {
    name: 'EntityEventListeners',
    components: {
        ListGroupCard,
        EntityEventListener,
    },
    data() {
        return {
            listener: false,
            entityEventListeners: new GenericCollection().setResourceName(
                'entityeventlisteners'
            ),
        }
    },

    created() {
        this.entityEventListeners.fetch()
    },

    methods: {
        setListener(listener) {
            this.listener = listener.item
        },

        addEventListener() {
            this.listener = this.entityEventListeners.createModel({
                name: '',
                enabled: false,
                actions: '',
                entity: '',
                event: 'created',
            })
            this.listener.setOption('overwriteIdentifier', true)

            this.listener.on('save', () => {
                this.entityEventListeners.fetch()
            })
        },
    },
}
</script>

<style></style>
